import {
  EnableAdUnits,
  ClearAds,
  LoadAdsPB,
} from "../Lib/gpt-ad-manager";
import { useEffect, useState, useRef, lazy, Suspense, useCallback, useMemo } from "react";
import useSessionStore from "../Lib/Context";
import "../App.css";
import Spinner from "../Components/Spinner";
import Text from "../Components/Text";
import {
  BtnContainer,
  Box,
  AppHeader,
  CustomTextParagraph,
  InfoTextParagraph,
  CustomTextContainer,
  LinkButton,
} from "../Components/ResponsiveLayout";
import Btn from "../Components/Button";
import { Authenticate } from "../Lib/Authentication";
import { logs } from "../Lib/fetch";
import ReactGA from "react-ga4";
import { showSuccess, showError, showInfo, showWarning, showLoading, dismissToast, ToastMessages } from "../utils/toast";

// Lazy load components that are conditionally rendered
const Terms = lazy(() => import("../Components/Terms&Service"));
const VideoErrorPage = lazy(() => import("../Components/VideoErrorPage"));
const ErrorPage = lazy(() => import("../Components/ErrorPage"));
const WatchVideo2 = lazy(() => import("./WatchVideo2"));

const googletag = window.googletag || (window.googletag = { cmd: [] });

function WatchVideo() {
  const { SessionData, setSessionData } = useSessionStore();
  const [IsLoading, setIsLoading] = useState(true);
  const [RewardedAd, setRewarded] = useState(false);
  const [IsOnline, setIsOnline] = useState(false);
  const [PageHeader, setPageHeader] = useState("Page1");
  const [DisplayFooter, setDisplayFooter] = useState(false);
  const [DisplayOnlineFooter, setDisplayOnlineFooter] = useState(false);
  const [IsTOSRequested, setIsTOSRequested] = useState(false);
  const [NextJourney, setNextJourney] = useState(false);
  const [isAuthenticating, setisAuthenticating] = useState(false);
  const [AuthenticationStatus, setAuthenticationStatus] = useState(false);
  const [ErrorStatus, setErrorStatus] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [ClickEventSend1, setClickEventSend1] = useState(true);
  const [Scrolltop, SetScrolltop] = useState(false);
  const [RefreshAds, setRefreshAds] = useState(false);
  const [RefreshAdsOnline, setRefreshAdsOnline] = useState(false);

  const [isRewardedReady_1, setisRewarded_1] = useState(false);
  const [isRewardGranted_1, setisRewardGranted_1] = useState(false);
  const [videoErrorState_1, setVideoErrorState_1] = useState(false);
  const [startVideo, setStartVideo] = useState(false);
  const [videoStarted, setVideoStarted] = useState(false);

  // Loading states for buttons
  const [isConnectLoading, setIsConnectLoading] = useState(false);
  const [isGoingOnline, setIsGoingOnline] = useState(false);

  // Video retry mechanism
  const [videoRetryCount, setVideoRetryCount] = useState(0);
  const [showSkipOption, setShowSkipOption] = useState(false);
  const MAX_RETRY_ATTEMPTS = 2;

  // Ref to track video state for timeout checks (avoids stale closure)
  const videoReadyRef = useRef(false);
  // Ref to store loading toast ID so it can be dismissed when video completes
  const loadingToastRef = useRef(null);

  useEffect(() => {
    // Ensure GPT is available
    if (startVideo) {
      if (window.googletag && googletag.apiReady) {
        let rewardedAdIsReady = false;
        // Define the ad slot for an out-of-page rewarded video
        let adUnitParent = SessionData.adUnitCode;
        console.log(`${adUnitParent}video_pri_bck`);
        googletag.cmd.push(() => {
          // Create a new out-of-page ad slot for the rewarded video
          const rewardedSlot_1 = googletag.defineOutOfPageSlot(
            `${adUnitParent}video_pri`,
            googletag.enums.OutOfPageFormat.REWARDED
          );

          // Make sure the slot was created successfully
          if (rewardedSlot_1) {
            console.log(SessionData.AdUnitTargeting.video_pri)

            // Slot-level category exclusions - block all non-video formats
            rewardedSlot_1.setCategoryExclusion('richmedia');
            rewardedSlot_1.setCategoryExclusion('html5');
            rewardedSlot_1.setCategoryExclusion('flash');
            rewardedSlot_1.setCategoryExclusion('image');
            rewardedSlot_1.setCategoryExclusion('interstitial');
            rewardedSlot_1.setCategoryExclusion('expandable');
            rewardedSlot_1.setCategoryExclusion('overlay');
            rewardedSlot_1.setCategoryExclusion('text');
            rewardedSlot_1.setCategoryExclusion('display');

            // Request video-only creatives
            rewardedSlot_1.setTargeting('ad_format', 'video');
            rewardedSlot_1.setTargeting('creative_type', 'video');
            rewardedSlot_1.setTargeting('media_type', 'video');

            // OpenRTB signals for Ad Exchange - VAST video only
            rewardedSlot_1.setTargeting('vapi', 'vast'); // Video API
            rewardedSlot_1.setTargeting('vpmute', '0'); // Unmuted video
            rewardedSlot_1.setTargeting('vpskip', '0'); // Non-skippable

            // Additional OpenRTB blocking for rich media
            rewardedSlot_1.setTargeting('btype', '1,2,3'); // Block banner, audio, native
            rewardedSlot_1.setTargeting('battr', '1,2,3,6,8,9,10,13,14,17'); // Block expandable/popup attributes

            // Apply slot-specific targeting from session data
            Object.keys(SessionData.AdUnitTargeting.video_pri).map((key) =>
              rewardedSlot_1.setTargeting(
                key,
                SessionData.AdUnitTargeting.video_pri[key]
              )
            );

            rewardedSlot_1.addService(googletag.pubads());
            
            googletag
              .pubads()
              .addEventListener("rewardedSlotReady", (event) => {
                rewardedAdIsReady = true;
                var elementPath = event.slot.getAdUnitPath();
                let slotId = cleanAdUnitPath(elementPath);
                let Impressiondetails = {
                  sessionID: SessionData.sessionID, 
                  event: "rewardedSlotReady",
                  slotID: slotId,
                  serviceName: "thinkzone",
                  slot: slotId,
                  payload: 1,
                };
                console.log("rewarded 1 ready");
                logs(Impressiondetails, SessionData);
                ReactGA.event("rewardedSlotReady", {
                  AdEvent: "rewardedSlotReady",
                });
                // event.makeRewardedVisible();
                setisRewarded_1(event);
              });
            // Listen for events like when the ad is closed or viewed
            googletag
              .pubads()
              .addEventListener("rewardedSlotClosed", function (event) {
                var elementPath = event.slot.getAdUnitPath();
                let slotId = cleanAdUnitPath(elementPath);
                let Impressiondetails = {
                  sessionID: SessionData.sessionID,
                  event: "rewardedSlotClosed",
                  slotID: slotId,
                  serviceName: "thinkzone",
                  slot: slotId,
                  payload: 1,
                };
                logs(Impressiondetails, SessionData);

                setTimeout(() => {
                  ReactGA.event("rewardedSlotClosed", {
                    AdEvent: "rewardedSlotClosed",
                  });
                  setVideoErrorState_1(true);
                }, 500);
              });
            googletag
              .pubads()
              .addEventListener("rewardedSlotVideoCompleted", function (event) {
                console.log("video completed");
              });
            googletag
              .pubads()
              .addEventListener("rewardedSlotGranted", function (event_1) {
                var elementPath = event_1.slot.getAdUnitPath();
                let slotId = cleanAdUnitPath(elementPath);
                let Impressiondetails = {
                  sessionID: SessionData.sessionID,
                  event: "rewardedSlotGranted",
                  slotID: slotId,
                  serviceName: "thinkzone",
                  slot: slotId,
                  payload: 1,
                };
                logs(Impressiondetails, SessionData);
                ReactGA.event("rewardedSlotGranted", {
                  AdEvent: "rewardedSlotGranted",
                });
                setisRewardGranted_1(true);
                setStartVideo(false);
                setTimeout(() => {
                  dismissRewardedAd();
                }, 2000);
              });
            googletag.display(rewardedSlot_1);
            googletag.pubads().refresh([rewardedSlot_1]);
            refreshRewardedAd();
          } else {
            console.log("Rewarded ads are not supported on this page.");
          }

          function refreshRewardedAd() {
            setTimeout(() => {
              if (!rewardedAdIsReady) {
                console.log("Video ad has failed");
                console.log("refreshing video ad");
                dismissRewardedAd();
                // window.location.reload();
                //googletag.pubads().refresh([rewardedSlot]);
              }
            }, 6000);
          }

          function dismissRewardedAd() {
            googletag.cmd.push(() => {
              googletag.destroySlots([rewardedSlot_1]);
              console.log(SessionData.targeting.lsale);
              setisRewardGranted_1(true);
            });
          }
        });
      }
    }
  }, [startVideo]);

  // Update ref when video becomes ready (to avoid stale closure in setTimeout)
  // Also dismiss loading toast when video is ready
  useEffect(() => {
    if (isRewardedReady_1 || isRewardGranted_1) {
      videoReadyRef.current = true;
      // Dismiss loading toast when video is ready
      if (loadingToastRef.current) {
        dismissToast(loadingToastRef.current);
        loadingToastRef.current = null;
      }
    }
  }, [isRewardedReady_1, isRewardGranted_1]);

  // Event handlers - Define these FIRST before using them in useMemo
  // Wrap handleClick in useCallback to prevent unnecessary re-renders
  const handleClick = useCallback(() => {
    setIsConnectLoading(true);
    const loadingToast = showLoading(ToastMessages.VIDEO_LOADING);
    loadingToastRef.current = loadingToast; // Store toast ID for later dismissal

    setRewarded(true);
    SetScrolltop(true);
    setDisplayFooter(false);
    ReactGA.event("video_1_click_to_view", {
      button_name: "watch video one",
      screen: "WatchVideo",
      retry_count: videoRetryCount
    });

    setStartVideo(true);
    // Graceful fallback: If video doesn't load in 4 seconds, allow user to continue
    setTimeout(() => {
      if (!videoReadyRef.current) {
        dismissToast(loadingToast);

        // Check if we should allow retry or skip
        if (videoRetryCount < MAX_RETRY_ATTEMPTS) {
          showWarning(`Video ad failed to load. Retrying... (${videoRetryCount + 1}/${MAX_RETRY_ATTEMPTS})`);
          setVideoRetryCount(prev => prev + 1);
          setIsConnectLoading(false);
          setShowSkipOption(true);
        } else {
          // Max retries reached, allow skip
          showWarning('Video ad unavailable. You can continue to connect.');
          setIsConnectLoading(false);

          // Allow flow to continue without video
          setTimeout(() => {
            setPageHeader("Online Page");
            setIsOnline(true);
            setDisplayFooter(false);
            setDisplayOnlineFooter(true);
            ClearAds(["page1_header", "page1_display"]);
            setVideoRetryCount(0); // Reset for next session
            setShowSkipOption(false);
            ReactGA.send({
              hitType: "pageview",
              page: "/Online",
              title: "Online - No Video",
            });
          }, 1000);
        }
      }
    }, 4000); // Reduced from 6s to 4s
  }, [videoRetryCount]); // videoReadyRef is a ref, doesn't need to be in deps

  // Wrap handleSkipVideo in useCallback
  const handleSkipVideo = useCallback(() => {
    setShowSkipOption(false);
    setIsConnectLoading(false);
    showInfo('Skipping video. You can now connect.');

    // Allow flow to continue without video
    setTimeout(() => {
      setPageHeader("Online Page");
      setIsOnline(true);
      setDisplayFooter(false);
      setDisplayOnlineFooter(true);
      ClearAds(["page1_header", "page1_display"]);
      setVideoRetryCount(0); // Reset retry count
      ReactGA.send({
        hitType: "pageview",
        page: "/Online",
        title: "Online - Skipped Video",
      });
    }, 500);
  }, []);

  // Wrap requestTOS in useCallback
  const requestTOS = useCallback(() => {
    setIsTOSRequested(true);
  }, []);

  // Wrap Journey2 in useCallback
  const Journey2 = useCallback(() => {
    SetScrolltop(true);
    setClickEventSend1(false);
    setNextJourney(true);
  }, []);

  // Memoize button text calculation to avoid recalculating on every render
  const connectButtonText = useMemo(() => {
    if (isConnectLoading) return 'LOADING...';
    if (videoRetryCount > 0) return 'RETRY VIDEO';
    return 'CONNECT TO WIFI';
  }, [isConnectLoading, videoRetryCount]);

  // Memoize online button text
  const onlineButtonText = useMemo(() => {
    return isGoingOnline ? 'CONNECTING...' : 'CLICK TO GO ONLINE';
  }, [isGoingOnline]);

  // Memoize ad targeting objects to prevent unnecessary re-renders
  const powerByTargeting = useMemo(() => ({ partner: SessionData.partner }), [SessionData.partner]);
  const page1HeaderTargeting = useMemo(() => SessionData.AdUnitTargeting.page1_header, [SessionData.AdUnitTargeting]);
  const onlineHeaderTargeting = useMemo(() => SessionData.AdUnitTargeting.online_header, [SessionData.AdUnitTargeting]);
  const page1DisplayTargeting = useMemo(() => SessionData.AdUnitTargeting.page1_display, [SessionData.AdUnitTargeting]);
  const onlineDisplayTargeting = useMemo(() => SessionData.AdUnitTargeting.online_display, [SessionData.AdUnitTargeting]);

  // Memoize Footer component to prevent unnecessary re-renders
  const Footer = useMemo(() => (
    <footer className="footer" role="contentinfo">
      <Box className="example-style">
        {!showSkipOption ? (
          <BtnContainer>
            <Btn
              className="sticky-button"
              onClick={handleClick}
              disabled={isConnectLoading}
              aria-label="Connect to WiFi by watching a short advertisement"
              aria-busy={isConnectLoading}
            >
              {connectButtonText}
            </Btn>
          </BtnContainer>
        ) : (
          <div className="d-flex" style={{ width: '100%', justifyContent: 'center', gap: '10px' }}>
            <BtnContainer style={{ width: '45%' }}>
              <Btn
                className="sticky-button"
                onClick={handleClick}
                aria-label="Retry loading video advertisement"
              >
                RETRY VIDEO
              </Btn>
            </BtnContainer>
            <BtnContainer style={{ width: '45%' }}>
              <Btn
                className="sticky-button"
                onClick={handleSkipVideo}
                aria-label="Skip video and continue to connect"
                style={{ backgroundColor: '#6366f1' }}
              >
                SKIP & CONTINUE
              </Btn>
            </BtnContainer>
          </div>
        )}

        <CustomTextParagraph aria-label="Advertisement banner">Powered by</CustomTextParagraph>
        <EnableAdUnits
          Name="powerby"
          Network={SessionData.adUnitCode}
          Targeting={powerByTargeting}
        />
        <LoadAdsPB Ads={["powerby"]} />
        <InfoTextParagraph role="note">
          By connecting, you agree to the Think Wifi
          <LinkButton
            className="sticky-button"
            onClick={requestTOS}
            aria-label="View Think WiFi Terms of Service"
          >
            Terms of Service
          </LinkButton>
        </InfoTextParagraph>
      </Box>
    </footer>
  ), [showSkipOption, isConnectLoading, connectButtonText, SessionData.adUnitCode, powerByTargeting, handleClick, handleSkipVideo, requestTOS]);

  // Memoize OnlineFooter component
  const OnlineFooter = useMemo(() => (
    <footer className="footer" role="contentinfo">
      <Box className="example-style box-height-1">
        <div className="d-flex" role="group" aria-label="Connection options">
          {/* <BtnContainer className="button-wid">
            <Btn className="sticky-button" onClick={Journey2}>
              Extend to 60 min
            </Btn>
          </BtnContainer> */}
          <BtnContainer className="button-wid">
            <Btn
              disabled={isDisabled || isGoingOnline}
              className="sticky-button"
              onClick={() => setisAuthenticating(true)}
              aria-label="Click to go online and connect to free WiFi"
              aria-disabled={isDisabled || isGoingOnline}
              aria-busy={isGoingOnline}
            >
              {onlineButtonText}
            </Btn>
          </BtnContainer>
        </div>
      </Box>
    </footer>
  ), [isDisabled, isGoingOnline, onlineButtonText]);

  // Memoize BodyParagraph component
  const BodyParagraph = useMemo(() => (
    <div>
      <CustomTextContainer style={{ flex: "none" }}>
        <Text.Text>
          <p>
            Welcome to
            <br />{" "}
            <Text.Text className="bold-text">
              {SessionData.partner_portal_description}
            </Text.Text>
            <br /> fast, free Wi-Fi.
          </p>
        </Text.Text>
      </CustomTextContainer>
    </div>
  ), [SessionData.partner_portal_description]);

  // Memoize OnlineBodyParagraph component
  const OnlineBodyParagraph = useMemo(() => (
    <div>
      <CustomTextContainer style={{ flex: "none" }}>
        {/* <Text.Paragraph1>
                <span className="bold-text">Almost Online</span>
                </Text.Paragraph1> */}
        <Text.Paragraph1>
          <span>
            {/* <span className="bold-text">Choose</span> your option below for */}
            <span className="bold-text">Enjoy your free WiFi</span>
          </span>
        </Text.Paragraph1>
        {/* <br />{" "}
        <Text.Paragraph1>
          <span className="bold-text">60 mins </span>
          <span>or</span>
          <span className="bold-text"> 30 mins ?</span>
        </Text.Paragraph1> */}
      </CustomTextContainer>
    </div>
  ), []);

  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: "/watchvideo",
      title: "Watch Video",
    });
    setTimeout(() => {
      setIsLoading(false);
    }, 2000);
  }, []);

  useEffect(() => {
    if (!IsLoading) {
      setTimeout(() => {
        setDisplayFooter(true);
        // setRefreshAds(true);
      }, 3000);
    }
  }, [IsLoading]);

  useEffect(() => {
    if (RefreshAds) {
      setTimeout(() => {
        setDisplayFooter(true);
      }, 3000);
    }
  }, [RefreshAds]);

  useEffect(() => {
    if (RefreshAdsOnline) {
      setTimeout(() => {
        setDisplayOnlineFooter(true);
      }, 4000);
    }
  }, [RefreshAdsOnline]);

  useEffect(() => {
    if (isRewardGranted_1) {
      console.log(SessionData);
      showSuccess(ToastMessages.VIDEO_COMPLETED);
      setIsConnectLoading(false);

      if (SessionData.portal_testing) {
        setPageHeader("Online Page");
        setIsOnline(true);
        setDisplayFooter(false);
        setRefreshAdsOnline(true);
        setIsLoading(false)
        ReactGA.send({
          hitType: "pageview",
          page: "/Online",
          title: "Online",
        });
      } else if (SessionData.firstPath === "fatti") {
        setPageHeader("Online Page");
        setIsOnline(true);
        setDisplayFooter(false);
        setRefreshAdsOnline(true);
        ReactGA.send({
          hitType: "pageview",
          page: "/Online",
          title: "Online",
        });
      } else {
        Journey2();
        console.log("Rewarded Extension granted");
      }
    }
  }, [isRewardGranted_1, SessionData]);
  // if (isRewardGranted) {
  //   const [isRewardedReady_1, isRewardGranted_1, videoErrorState_1] =
  //     EnableRewardedVideo({ adUnit: "video_sec" });
  //   isRewardedReady_1.makeRewardedVisible();
  // }

  function cleanAdUnitPath(adUnitPath) {
    var result = adUnitPath.split("/");
    return result[3];
  }
  useEffect(() => {
    if (isRewardedReady_1) {
      // console.log(isRewardedReady_1.slot.getAdUnitPath());
      isRewardedReady_1.makeRewardedVisible();
    }
  }, [isRewardedReady_1]);

  useEffect(() => {
    if (isAuthenticating) {
      setIsGoingOnline(true);
      setIsLoading(true);
      const authToast = showLoading(ToastMessages.CONNECTING);

      Authenticate(SessionData, setSessionData)
        .then(() => {
          dismissToast(authToast);
          showSuccess(ToastMessages.CONNECTED);
        })
        .catch((error) => {
          console.error('Authentication failed:', error);
          dismissToast(authToast);
          showError(ToastMessages.CONNECTION_FAILED);
          setErrorStatus('Authentication failed. Please try again.');
        })
        .finally(() => {
          setisAuthenticating(false);
          setIsGoingOnline(false);
        });
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAuthenticating]); // SessionData intentionally excluded - effect modifies it via Authenticate()

  useEffect(() => {
    if (SessionData.auth_result) {
      if (SessionData.auth_result.status !== "error") {
        if (ClickEventSend1) {
          let clickEvent = {
            sessionID: SessionData.sessionID,
            clientID: SessionData.clientID,
            button_id: "go_online_1",
            button_url: SessionData.UserRedirectUrl,
            event: "clickEvent",
            campaign_code: SessionData.campaign_code,
          };
          logs(clickEvent, SessionData);
          setClickEventSend1(false);
          setAuthenticationStatus(true);
        }
      } else if (SessionData.auth_result.status === "error") {
        setErrorStatus(true);
      } else {
        setErrorStatus("Authentication Failed");
      }
    }
  }, [SessionData, ClickEventSend1]);

  useEffect(() => {
    if (AuthenticationStatus) {
      window.open(SessionData.UserRedirectUrl, "_blank");
      window.location.href = SessionData.UserRedirectUrl;
    }
  }, [AuthenticationStatus, SessionData]);

  useEffect(() => {
    if (Scrolltop) {
      window.scrollTo(0, 0);
    }
  }, [Scrolltop]);

  if (RewardedAd) {
    ClearAds(["page1_header", "page1_display"]);
  }

  if (videoErrorState_1 && !isRewardGranted_1) {
    return (
      <Suspense fallback={<Spinner />}>
        <VideoErrorPage />
      </Suspense>
    );
  }
  if (IsTOSRequested) {
    return (
      <Suspense fallback={<Spinner />}>
        <Terms />
      </Suspense>
    );
  }
  if (NextJourney) {
    return (
      <Suspense fallback={<Spinner />}>
        <WatchVideo2 />
      </Suspense>
    );
  }
  if (ErrorStatus) {
    return (
      <Suspense fallback={<Spinner />}>
        <ErrorPage errMsg={ErrorStatus} />
      </Suspense>
    );
  }

  return (
    <div role="main" aria-label="WiFi Connection Portal">
      {/* Loading states with ARIA live regions */}
      {IsLoading && <div role="status" aria-live="polite"><Spinner /></div>}
      {isAuthenticating && <div role="status" aria-live="polite"><Spinner /></div>}
      {startVideo && <div role="status" aria-live="polite"><Spinner /></div>}

      <div>
        {/* Accessible page heading */}
        <h1 className="sr-only">{PageHeader}</h1>

        <div id="Header" role="banner" aria-label="Header banner advertisement">
          <AppHeader>
            <EnableAdUnits
              Name="page1_header"
              Network={SessionData.adUnitCode}
              Targeting={page1HeaderTargeting}
            />
            <EnableAdUnits
              Name="online_header"
              Network={SessionData.adUnitCode}
              Targeting={onlineHeaderTargeting}
            />
            <LoadAdsPB
              Ads={["page1_header"]}
            />
            {RefreshAds && (
              <LoadAdsPB
                Ads={["page1_header"]}
              />
            )}
            {/* {RefreshAdsOnline && (
              <LoadAdsPB
                Ads={["online_header"]}
              />
            )} */}
            {IsOnline && (
              <LoadAdsPB
                Ads={["online_header"]}
              />
            )}
          </AppHeader>
        </div>
        <section aria-label="Main content">
          {!IsOnline && BodyParagraph}
          {IsOnline && OnlineBodyParagraph}
        </section>
        <div id="Display" role="region" aria-label="Display advertisement">
          <EnableAdUnits
            Name="page1_display"
            Network={SessionData.adUnitCode}
            Targeting={page1DisplayTargeting}
          />
          <EnableAdUnits
            Name="online_display"
            Network={SessionData.adUnitCode}
            Targeting={onlineDisplayTargeting}
          />
          <LoadAdsPB
            Ads={["page1_display"]}
          />
          {RefreshAds && (
            <LoadAdsPB
              Ads={["page1_display"]}
            />
          )}
          {/* {RefreshAdsOnline && (
            <LoadAdsPB
              Ads={["online_display"]}
            />
          )} */}
          {IsOnline && (
            <LoadAdsPB
              Ads={["online_display"]}
            />
          )}
        </div>
        <div>
          {DisplayFooter && Footer}
          {DisplayOnlineFooter && OnlineFooter}
        </div>
        {/* <button onClick={handleClick}>Click me</button>  */}
      </div>
    </div>
  );
}

export default WatchVideo;
